import { Box, CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { BasicTable } from '@components';
import {
  customerDetailsStore,
  CustomerOrderSummary,
} from '@store/customers/customerDetails';
import { formatAmount } from '@utils/utils';
const OrderSummary = () => {
  const columns = [
    {
      name: 'Status',
      key: 'status',
    },
    {
      name: 'Load Count',
      key: 'orders',
    },
    {
      name: 'Amount',
      key: 'amount',
      renderCell: (row: CustomerOrderSummary) => formatAmount(row.amount),
    },
  ];

  return (
    <CollapsibleCard startTitle="Order Summary" class="mb-2">
      <Box
        style={{
          height: 'auto',
          'max-height': '350px',
          'overflow-y': 'auto',
        }}
        class="[&>div>table>.MuiTableHead-root]:bg-[#f2f2f2]"
      >
        <BasicTable
          columns={columns}
          rows={customerDetailsStore.customer.orderSummary || []}
        />
      </Box>
    </CollapsibleCard>
  );
};

export default OrderSummary;
